import React, { useEffect, useState } from 'react';
import { Pagination, ProjectCard } from 'components'
import { useApp, usePermission } from 'hooks';

const Projects = () => {
    const { can } = usePermission()
    const [currentPage, setCurrentPage] = useState(1);
    const { onUpdateParams, projectData, projectCurrentPage } = useApp();

    const [dataTable, setDataTable] = useState({
        data: [],
        totalPage: 1,
    });

    useEffect(() => {
        currentPage !== projectCurrentPage && onUpdateParams({ projectCurrentPage: currentPage })
    }, [currentPage, projectCurrentPage]);

    useEffect(() => {
        if (projectData?.data) {
            setDataTable(projectData);
        }
    }, [projectData]);

    return (
        <div className="bg-gray-50 min-h-screen">
            <div className="grid grid-cols-[repeat(auto-fill,minmax(400px,1fr))] gap-6">
                {dataTable.data.map((p, i) => {
                    if (!can(p.status, "project")) return <></>;
                    return (
                        <ProjectCard key={`project${i}`} {...p} />
                    )
                })}
            </div>
            {dataTable.totalPage > 1 && <div className="flex items-center justify-between mt-10 text-sm text-gray-500">
                <div className="space-x-2">
                    <Pagination currentPage={currentPage} totalPages={dataTable.totalPage} onPageChange={(p) => { setCurrentPage(p); onUpdateParams({ projectCurrentPage: p }) }} />
                </div>
                <span></span>
            </div>}
        </div>
    )
}

export default Projects
